import React from 'react';
import './Pill.css';

function Pill({
  variant = 'neutral',
  fullText = false,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'ui-pill',
    `ui-pill--${variant}`,
    fullText ? 'full-text-value' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}

export default Pill;
